import Ajax from './ajax';

export default class {
    ajax;
    btnsFormCallback = document.querySelectorAll('.js_form-callback-submit');

    constructor() {
        this.ajax = new Ajax;
        this.listen();
    }

    showSuccessModal() {
        let modalSuccess = new bootstrap.Modal(document.getElementById('modalCallbackSuccess'));
        modalSuccess.show();
    };

    listen() {
        this.btnsFormCallback.forEach(btnSubmit => {
            btnSubmit.addEventListener('click', (event) => {
                event.preventDefault();
                let form = btnSubmit.closest('.js_form-callback'),
                    data = {
                        name: form.querySelector('.js_callback-name').value,
                        phone: form.querySelector('.js_callback-phone').value,
                    }

                form.querySelectorAll('.is-invalid').forEach(n => n.classList.remove('is-invalid'));

                let success = (response) => {
                    if (response.data.result == 'success') {
                        if (btnSubmit.closest('.modal')) {
                            let btnCloseCallbackModal = btnSubmit.closest('.modal').querySelector('.btn-close')
                            btnCloseCallbackModal.click();
                            form.reset();
                        }
                        setTimeout(() => {
                            this.showSuccessModal();
                        }, 50)
                    }
                };

                let fail = (error) => {
                    if (error.response.data.errors) {
                        let errors = error.response.data.errors;
                        for (var e in errors) {
                            let el = form.querySelector('input[name="' + e + '"]');
                            el.classList.add('is-invalid');
                        }
                    }
                };

                this.ajax.send(data, success, fail);
            });
        })
    }
}
